import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {VirtualMetricOPEEnum} from "./VirtualMetricOPEEnum";
import {VMInput, VMScheduledConfig, VMTypeEnum} from "../../models/virtualmetric/VirtualMetric";


class O {
  valid!: boolean;
  warning?: string;
}

/**
 * O Inner Class
 */
class I {

  type!: VMTypeEnum;
  expression!: string;
  isBoolean!: boolean;
  scheduledConfig!: VMScheduledConfigDTO;
  resettableConfig!: VMResettableConfigDTO;
}

export class VMScheduledConfigDTO {
  inputMetrics: VMInputDTO[] = [];

  constructor(scheduledConfig: VMScheduledConfig) {
    this.inputMetrics = [];
    scheduledConfig.inputMetrics.forEach(
      metric => {
        this.inputMetrics.push(new VMInputDTO(metric));
      }
    )
  }
}

export class VMResettableConfigDTO {

  metricInstanceId!: number;
  alias!: string;

}

class VMInputDTO {
  metricInstanceId!: number;
  alias!: string;

  constructor(vmInput: VMInput) {
    if (!!vmInput.fullMetricInstance) {
      this.metricInstanceId = vmInput.fullMetricInstance?.id;
    }
    this.alias = vmInput.alias;
  }

}

/**
 * GetTransportItemDetailCB class
 */
export class CheckVirtualMetricExpressionCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(VirtualMetricOPEEnum.CheckVirtualMetricExpression);
    this.i = new I();
    this.o = new O();
  }

}
